import db from "~/src/db/voir-contents";
import { SPEC_ORDER } from "~/src/constants/spec";

const AVAILABLE_KEYS = Object.keys(db); // ["amenabar", "cespedes", ...]

const usePage = () => {
  const pathname = window.location.pathname;

  // Extrae el nombre del proyecto desde la URL (funciona con /index.html o /)
  const match = pathname.match(/^\/voir\/([^/]+)/);
  const key = match?.[1];

  if (!AVAILABLE_KEYS.includes(key)) {
    window.location.replace("/");
    throw new Error("Page not found");
  }

  /** @type {Page} */
  const page = db[key];

  const getMapInfo = () => page.map;
  const getVideo = () => page.video;
  const getName = () => key.charAt(0).toUpperCase() + key.slice(1);
  const getSidetext = () => page.sidetext;
  const getCarousel = () => page.carousel;
  const getTags = () => {
    const [entrega, period, environments, state, location] = page.tags;

    return { entrega, period, environments, state, location };
  };
  const getEnvImage = (env, dimension) => page.environment[env][dimension];
  const getEnvs = () => Object.keys(page.environment);
  const getAvailableDimesions = (env) =>
    Object.keys(page.environment[env]).filter(
      (k) =>
        ![
          "surface",
          "environments",
          "bathrooms",
          "rooms",
          "toilets",
          "kitchens",
        ].includes(k)
    );
  const getAvailableSpecs = (env) =>
    Object.keys(page.environment[env])
      .filter((k) =>
        [
          "surface",
          "environments",
          "bathrooms",
          "rooms",
          "toilets",
          "kitchens",
        ].includes(k)
      )
      .sort((a, b) => SPEC_ORDER.indexOf(a) - SPEC_ORDER.indexOf(b));
  const getEnvSpecs = (env) => {
    const { bathrooms, rooms, environments, surface, toilets, kitchens } =
      page.environment[env];

    return {
      bathrooms,
      rooms,
      environments,
      surface,
      toilets,
      kitchens,
    };
  };
  const getEnvDefaults = () => {
    const defaultKey = Object.keys(page.environment)[0];

    const specs = getEnvSpecs(defaultKey);
    const availableDimesions = getAvailableDimesions(defaultKey);
    const availableSpecs = getAvailableSpecs(defaultKey);
    const preview = getEnvImage(defaultKey, availableDimesions[0]);

    return {
      key: defaultKey,
      preview,
      specs,
      availableDimesions,
      availableSpecs,
    };
  };
  const getBrochure = () => page.brochure;

  return {
    getMapInfo,
    getVideo,
    getName,
    getSidetext,
    getCarousel,
    getTags,
    getEnvImage,
    getEnvs,
    getEnvSpecs,
    getEnvDefaults,
    getBrochure,
    getAvailableDimesions,
    getAvailableSpecs,
  };
};

export default usePage;
